import { RootState } from '@AppState/redux-store'
import { useSelector } from 'react-redux'
import { ReactSVG } from 'react-svg'
import { Button } from './button'
import { ContainerMessage, ContainerMessenger } from '@Util/container-messenger'
import { CloseButton } from '@Components/close-button/close-button'
import { useCallback } from 'react'

const CLASS_NAME = 'user-message'

export type UserMessageProps = {
  title: string
  message: string
}

const onExit = () => {
  ContainerMessenger.sendMessage(ContainerMessage.EXIT)
}

export const UserMessage = ({ title, message }: UserMessageProps) => {
  const hostConfig = useSelector((state: RootState) => state.hostConfig.config)

  const refreshHandler = useCallback(() => {
    window.location.reload()
  }, [])

  return (
    <div className={CLASS_NAME}>
      <CloseButton className={`${CLASS_NAME}__close`} onClick={onExit} />
      <section className={`${CLASS_NAME}__content-area`}>
        {hostConfig?.icons.gameUrl ? (
          <ReactSVG
            className={`${CLASS_NAME}__logo`}
            src={hostConfig.icons.gameUrl}
            beforeInjection={(svg) => {
              svg.removeAttribute('width')
              svg.removeAttribute('height')
              svg.setAttribute('preserveAspectRatio', 'xMinYMin meet')
              svg.style.width = '100%'
              svg.style.maxHeight = '150px'
            }}
          />
        ) : null}
        <div>{title}</div>
        <div className={`${CLASS_NAME}__description`}>{message}</div>
        <Button
          classPrefix={`${CLASS_NAME}__footer_close`}
          text="Refresh"
          onClick={refreshHandler}
        />
        <Button classPrefix={`${CLASS_NAME}__footer_close`} text="Close" onClick={onExit} />
      </section>
    </div>
  )
}
